module.exports = {
  TITLE: {
    default: 'Cari Hotel|Ribu-ran hotel di Asia boleh didapati dalam talian untuk tempahan',
    detail: '|Tempahan Hotel',
  },
  hotel: {
    // 酒店搜索改版新增翻译--英文
    ROOMS: 'Bilik',
    GUESTS: 'Tetamu',
    CHECK_IN_NUM: 'Tetamu',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Dewasa',
    SUFFIX_ADULTS: 'Dewasa',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Kanak-kanak',
    SUFFIX_CHILDREN: 'Kanak-kanak',
    CHILD_AGE: 'Umur Kanak-kanak',
    NO_MATCH_TIPS: 'Jenis bilik di bawah tidak sepadan dengan bilangan bilik dan tetamu yang anda pilih.',

    Book_Hotel: 'Tempah Hotel',
    Select_your_destination: 'Pilih destinasi anda',
    Please_enter_your_destination: 'Sila masukkan destinasi/hotel anda',
    Booked_up: 'Ditempah penuh',
    Hotel_description: 'Penerangan Hotel',
    Check_in_date: 'Tarikh Daftar Masuk',
    Check_out_date: 'Tarikh Daftar Keluar',
    Sold_out: 'Dijual habis',
    Non_refundable: 'Tidak boleh dikembalikan',
    reserve: 'Tempah',
    Pay_Online: 'Bayar secara dalam talian',
    Only_rooms_left_before: 'Hanya ',
    Only_rooms_left_after: ' bilik tinggal',
    Cancellation_Policy: 'Polisi Pembatalan',
    See_all_prices_before: 'Lihat semua ',
    See_all_prices_after: 'harga',
    Estimated_time_of_arrival: 'Masa kedatangan yang dianggarkan',
    make_your_schedule_well_planned: 'Masa adalah mengikut zon masa tempatan, sila jadualkan dengan baik dan tiba tepat pada masanya.',
    Hotel_Not_Found: 'Hotel Tidak Ditemui',
    Please_change_your_search: 'Sila ubah carian anda',
    Submit_an_application: 'Hantar permohonan',
    Hotel_Confirmation: 'Pengesahan Hotel',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Malam Penginapan',
    Hotel_Booking_Number: 'Nombor Tempahan Hotel',
    Online_Payment: 'Bayaran Dalam Talian',
    The_guest_Room_before: 'Tetamu[Bilik',
    The_guest_Room_after: ']',
    Contact_number: 'nombor hubungan',
    Bring_all_valid_IDs: 'Sila bawa semua kad pengenalan yang sah untuk semua tetamu semasa mendaftar masuk.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hotel Ditemui',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hotel Dipersembahkan (',
    Hotels_Presented_after: ' secara keseluruhan)',
    Please_change_the_dates: 'Bilik tidak tersedia pada tarikh anda, sila ubah tarikh.',
    Login: 'Log masuk ke aplikasi untuk tempah hotel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Malam secara keseluruhan',
    Location: 'Lokasi',
    Pictures: 'Gambar',
    Description: 'Penerangan',
    Policy: 'Polisi',
    Check_in_and_check_out_time: 'Masa daftar masuk dan daftar keluar',
    Check_in_and_Check_out_before: 'Daftar masuk: selepas ',
    Check_in_and_Check_out_center: 'Daftar keluar: sebelum ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Masa daftar masuk',
    Check_out_time: 'Masa daftar keluar',
    Hotel_Information: 'Maklumat Asas',
    Opening_Date: 'Tarikh Pembukaan',
    Renovation_Date: 'Tarikh Pengubahsuaian',
    Facility_Service: 'Fasiliti & Perkhidmatan',
    Payment_methods: 'Kaunter pembayaran diterima oleh hotel',
    Hotel_Address: 'Alamat Hotel',
    Pay_online: 'Bayar dalam talian',
    Pay_offline: 'Bayar secara luar talian',
    Night_stay_before: '',
    Night_stay_after: '-Malam Penginapan,',
    Rooms_total_before: 'Bilik',
    Rooms_total_after: 'secara keseluruhan',
    Guest_name_must_be_provided: 'Nama penuh tetamu mesti diberikan.',
    Please_fill_in_your_contact_number: 'Sila isi nombor hubungan anda',
    Select_estimated_time_of_arrival: 'Pilih masa kedatangan yang dianggarkan',
    Number_of_Rooms: 'Bilangan Bilik',
    Maximum_guests_per_room_before: 'Maksimum ',
    Maximum_guests_per_room_after: ' tetamu setiap bilik',
    Many_Rooms: ' Bilik',
    Service_Fee_Included: '(Cukai & Caj Perkhidmatan Termasuk)',
    Last_Name: 'Nama Belakang',
    First_Name: 'Nama Depan ',
    Room: 'Bilik',
    Additional_Tax: 'Cukai Tambahan',
    Please_inform_the_hotel: 'Jika anda tiba selepas masa kedatangan yang dianggarkan, sila beritahu hotel terlebih dahulu.',
    Please_inform_the_hotel_first: 'Ketibaan di hotel selepas masa kedatangan yang dianggarkan tanpa menghubungi hotel terlebih dahulu akan mempengaruhi ketersediaan bilik dan makan malam. Sila beritahu hotel terlebih dahulu untuk mengesahkan ketersediaan dalam keadaan sedemikian.',
    Booking_Cancellation: 'Pembatalan Tempahan',
    Reason_of_Cancellation: 'Sebab Pembatalan',
    Incorrect_Information_Filled: 'Maklumat yang Diisi Tidak Tepat',
    Itinerary_Changed: 'Jadual Perjalanan Diubah',
    Lower_price_on_other_APP: 'Harga lebih rendah di aplikasi lain',
    Low_quality_hotel: 'Hotel berkualiti rendah',
    Book_at_a_lower_price: 'Tempah dengan harga lebih rendah di kaunter',
    Other: 'Lain-lain',
    Please_write_your_reason: 'Sila tulis sebab anda',
    After_cancellation_done: 'Setelah pembatalan selesai, bayaran akan dikembalikan kepada pembayar asal dalam masa 3 hari kerja.',
    How_to_fill_in_the_guest_name: 'Cara mengisi nama tetamu',
    It_should_be_exactly_the_same: 'Sila berikan nama tetamu dalam huruf Inggeris untuk tempahan hotel. Ia harus sama persis seperti sijil yang dikemukakan semasa mendaftar masuk.',
    How_to_fill_in_a_Chinese_name: 'Cara mengisi nama Cina:',
    How_to_fill_in_a_English_name: 'Cara mengisi nama Inggeris',
    For_example: 'Contohnya: Jika nama Cina anda ialah “韩梅梅”, nama belakang adalah "Han", nama depan adalah "Meimei".',
    No_specical_characters: 'Jangan mengisi nombor atau aksara khas.',
    Name_rule_first: 'Nama belakang datang dahulu, nama depan mengikut, dan jika ada nama tengah, ia diikuti dengan ruang di belakang kedua-dua nama itu.',
    Name_rule_second: 'Contohnya: Green / Jim Stephanie',
    Details: 'Butiran',
    Pay_now: 'Bayar sekarang',
    Hotel: 'Hotel',
    Check_in: 'Daftar masuk',
    Car: 'Kereta',
    All_bookings: 'Semua tempahan',
    All: 'Semua',
    PROMPT: 'Perhatian',
    NETWORK_TIMEOUT: 'Masa tamat rangkaian, sila hantar pesanan semula',
    ORDER_SUBMIT_SLOW: 'Submitting your order, please wait… (supplier confirmation may take a while, do not close the page or submit again)',
    ORDER_SUBMIT_UNKNOWN: 'Order result unknown. Please check "My Orders" before trying again — do not place the same order twice',
    REQUEST_FAIL: 'Permintaan gagal, sila cuba lagi kemudian',

    Search: 'Carian',
    COST_DESCRIPTION: 'Butiran Harga',
    TOTAL: 'Jumlah',
    SEE_ORDER_INFO_TO: 'Bayar',
    KONW: 'Faham',
    BOOKING_INFORMATION: 'Maklumat Penting',
    Book_Now: 'Bayar Sekarang',
    MAP: 'Peta',
    CONTACT_INFORMATION: 'Maklumat Hubungan',
    LOADING: 'Memuatkan...',
    SORT_FILTER: 'Isihan/Filter',
    SCREENING: 'Tapis',
    SEQUENCE: 'Susunan',
    PHONE_ASK: 'Hubungi kami',
    ABOVE: '',
    SUBMINT_ORDER: 'Hantar',
    OK: 'OK',
    Order_detail: 'Butiran Tempahan',
    BOOKING_INFO: 'Maklumat Tempahan',
    PAYMENT_AMOUNT: 'Jumlah Bayaran',
    Order_time: 'Masa Tempahan',
    ORDER_NUMBERS: 'Nombor Tempahan',
    PAY_TYPE: 'Cara Pembayaran',
    BALANCE: 'Baki',
    CURRENT_BALANCE_BEGIN: 'Baki',
    OVERPLUS_BALANCE_BEGIN: 'Baki Tersisa',
    OTHER_PAYMENT: 'Kaunter pembayaran lain',
    Unionpay: 'UnionPay',
    Wechatpay: 'Bayaran WeChat',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Klik pada “Bayar Sekarang” bermakna anda bersetuju dengan Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Perjanjian Perkhidmatan》',
    PAYMENT_ORDER: 'Pembayaran Tempahan',
    Total_pay: 'Jumlah yang Perlu Dibayar',
    PAY_SUCCESS: 'Pembayaran Diterima',
    CHECK_THE_ORDER: 'Semak Tempahan',
    BACK_TO_INDEX: 'Kembali ke Indeks',
    CANCEL: 'Batal',
    RECOMMED: 'Syorkan',
    PRICE: 'Harga',
    HIGH: 'Tinggi',
    LOW: 'Rendah',
    RESET: 'Set Semula',
    SELECT_TIME: 'Pilih Tarikh',
    Hotel_guest: 'Tetamu Hotel',
    Select: 'Sila Pilih',
    Emial_address: 'Sila masukkan alamat emel',
    Booking_explan: 'Maklumat Tempahan',
    VIEW_MORE: 'Lihat lebih banyak',
    COLLAPSE: 'Sembunyi',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Daftar masuk',
    TOURISM_LEAVE_HOTEL: 'Daftar keluar',
    arrive: 'Destinasi',
    Room_description: 'Penerangan Bilik',
    Meals: 'Makanan',
    Room_Type: 'Jenis Bilik',
    BOOKING_EXPLANATION: 'Maklumat Tempahan',
    BOOKING_BUTTON: 'Tempah',
    REMIND_SUBMIT_ORDER: 'Teruskan',
    login_now: 'Tempahan hotel perlu log masuk, log masuk sekarang?',
    the_real_scene: 'Gambar hanya sebagai rujukan dan tertakluk kepada senario sebenar.',
    Bed: 'Katil',
    Rooms: 'Bilik',
    Room_rate: 'Kadar Bilik',
    notified_by_SMS: 'Selepas tempahan berjaya, anda akan dimaklumkan melalui SMS',
    email_notifications: 'Digunakan untuk menerima pemberitahuan melalui emel',
    Booking_deadline: 'Tempoh tempahan',
    Child: 'Kanak-kanak',
    Additional_notes_about_payment: 'Nota tambahan mengenai pembayaran',
    Nights: 'Malam',
    Minimum_nights_before: 'Minimum',
    Minimum_nights_after: 'malam',
    Size: 'Saiz',
    Guests: 'Tetamu',
    Room_rate_1: 'Kadar Bilik',
    Tax_service_fee: 'Cukai/caj perkhidmatan',
    Pay_now_1: 'Bayar sekarang',
    Filter: 'Tapis',
    Room_rate2: 'Kadar Bilik',
    Show_on_map: 'Paparkan di peta',
    Detail: 'Butiran',
    Room_Detail: 'Butiran Bilik',

    TAXES_INCL: 'Cukai termasuk.',
    SEARCH_EMPTY_TIP: 'Maaf, tiada ketersediaan pada tarikh yang anda pilih, anda boleh: cari tarikh atau hotel alternatif',
    severalNight: 'Malam',
    immediateBooking: 'Tempah Sekarang',
    Refundable: 'Boleh dikembalikan',
    MORE: 'Lain-lain',
    adultsCompany: 'dewasa',
    ServiceTerms: 'Perkhidmatan & Terma',
    roomPlan: 'Pelanjutan',
    guestRoom: 'Bilik',
    searchAgain: 'Cari lagi',
    roomNight: 'bilik/malam',

    NAME_TXT: 'Nama',
    HOLDER_NAME: 'Nama Pemegang Kad',
    EXPIRATION_DATE: 'Tarikh Tamat Tempoh',
    FORMAT_TXT: 'Format',
    SECURITY_CODE: 'Kod Keselamatan',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: '3 digit di belakang kad.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 digit di bahagian depan kad',
    ENTER_COMPLETE_CARD_NUM: 'Sila masukkan nombor kad yang lengkap.',
    PLEASE_ENTER_HOLDER_NAME: 'Masukkan nama pemegang kad',
    ENTER_SECURITY_CODE: 'Masukkan kod keselamatan',
    ENTER_EXPIRATION_DATE: 'Masukkan tarikh tamat tempoh',

ROOM_DETAILS: 'Butiran Bilik',
CONDITION_CANCEL: 'Boleh Dikembalikan',
CHOOSE_PAYMENT_METHOD: 'Bayaran',
ORDER_TOTAL_LUMP: 'Jumlah Keseluruhan',
CREDIT_CARD_NUM: 'Nombor Kad Debit / Kredit',
MAINLAND_CARD_ONLY: 'Kad bank yang dikeluarkan di luar China Utama sahaja.',
SHUT_DOWN: 'Tutup',
PROVIDER_FROM_CHINA_BANK: 'Perkhidmatan pembayaran disediakan oleh B.O.C',

COUPON: 'Kupon',
APPLY_A_COUPON: 'Gunakan Kupon',
NO_USE: 'Tidak berkenaan untuk perjanjian ini.',
Discard: 'Tolak',
REDEEM: 'Tukarkan',
EMPTY_COUPON: 'Sila masukkan kod promosi',
NOTICE_COUPON: 'Hanya satu kupon boleh ditukarkan untuk setiap tempahan; kupon akan ditukarkan setelah tempahan dihantar.',

BREAKFAST_INCLUDE: 'sarapan termasuk',
BREAKFAST_EXCLUDE: 'sarapan tidak termasuk',
DOUBLE_BED: 'katil dua',
TWIN_BED: 'katil kembar',
FREE_CANCEL: 'pembatalan percuma',
MEALS: 'hidangan',
EVALUATION: 'Ulasan',
FEATURED_REVIEWS: 'Ulasan Unggulan',
ALL_REVIEWS: 'Semua Ulasan',
OVERALL_EVALUATION: 'Ulasan Keseluruhan',
ANONYMOUS: 'Anonim',
EVAL_GENERAL_LIST_1: 'Lemah',
EVAL_GENERAL_LIST_2: 'Sederhana',
EVAL_GENERAL_LIST_3: 'Sederhana',
EVAL_GENERAL_LIST_4: 'Baik',
EVAL_GENERAL_LIST_5: 'Cemerlang',
MAX_IMAGES_WITH_NINE: 'Maksimum 9 gambar boleh dipilih.',
GRADE_EVAL: 'Sila pilih Penilaian Keseluruhan',
DISTANCE_FILTER: 'jarak dekat-jauh',
EDIT_EVALUATION: 'beri komen',
GO_TO_EVAL: 'beri komen',
EVAL_POINTS_AWARD: 'Komen baik boleh menang 1000 mata, 1000 mata = 10RMB',
NEARBY_LIKE_HOTEL: 'hotel serupa berdekatan',
DISTANCE_HOTEL: 'ke hotel',
PLEASE_ENTER_COMMENT: 'komen',
AWARD_POINTS_TIPS: 'Komen terbaik boleh mendapat 1000 mata 1000 = 10RMB',
NO_SHOW_ANONYMOUS_AVATAR: 'Komen anonim tidak akan menunjukkan logo dan nama anda',
LOCATION: 'lokasi',
FACILITY: 'kemudahan',
SERVICE: 'perkhidmatan',
HEALTH: 'bersih',
LANGUAGE_SELECT: 'bahasa',
LIMIT_COMMENT_TXT: 'Ulasan mesti mempunyai 5~2000 aksara',
SHARE_MEDIA: 'Kongsi gambar dan video',
SETTLEMENT_FEEL: 'Komen',
SUBMIT_EVAL: 'Sahkan',
HOTEL_STR: 'Butiran',
EVAL_NUM_AFTER: 'ulasan',
},
header: {
SKIING: 'Resort Ski',
header_internal_call: 'China Utama:',
header_abroad_call: 'Antarabangsa:',
header_app_download: 'Aplikasi Mudah Alih',
service_telephone: 'Khidmat Pelanggan',
account_number: 'Akaun',
if_bg_user: 'Bukan Ahli BaiGolf?',
home: 'Laman Utama',
hotel: 'Hotel',
Golf: 'Golf',
PLAY_STAY: 'Inap & Main',
RENT_CAR_HOME: 'Kereta',
center_user: 'Pusat Ahli',
header_my_order: 'Tempahan Saya',
header_notmember_order: 'Tempahan Tetamu',
header_edit_password: 'Tukar Kata Laluan',
header_logout: 'Log keluar',
header_login: 'Log masuk',
header_register: 'Daftar',
header_point: 'Mata Saya',
header_all_language: 'Semua Bahasa',
down_load_app: 'Imbas Kod QR untuk Muat Turun',
login_discount_tip: 'Log masuk untuk mendapatkan bonus dan nikmati faedah eksklusif anda',
currency_balance_limit: 'Mata wang semasa masih mempunyai baki, tidak boleh tukar mata wang'
},
footer: {
footer_partner: 'Rakan Kongsi',
footer_about_us: 'Tentang Kami',
footer_about_baigolf: 'Tentang BaiGolf.com',
footer_privacy_policy: 'Dasar Privasi BaiGolf.com',
footer_use_of_terms: 'Terma Perkhidmatan BaiGolf.com',
footer_contact_us: 'Hubungi Kami',
footer_sitemap: 'Peta Laman',
footer_use_of_question: 'Soalan Lazim',
footer_ios_system: 'iOS',
footer_android_system: 'Android',
footer_app_load: 'Muat Turun APP',
footer_sina_weibo: 'Sina Weibo',
footer_tencent_weibo: 'Tencent mikroblog',
footer_share_to: 'Kongsi',
copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Hak Cipta ',
copyright2: 'Yue ICP Pendaftaran No.14070002',
news_center: 'Pusat Berita',
about_baigolf: 'Mengenai BaiGolf',
help: 'Bantuan',
management_system: 'Sistem Pengurusan BG Golf (BGMS)',
wechat_official_account: 'Akaun Rasmi WeChat',
download_baiGolf_app: 'Muat Turun Aplikasi BaiGolf',
privacy_policy: 'Dasar Privasi',
use_of_terms: 'Terma Perkhidmatan',
footer_integral: 'Dasar Mata',
footer_reserve: 'Dasar Tempahan',
footer_abroad_call: 'Antarabangsa',
footer_internal_call: 'China Utama'

  }
}



// WEBPACK FOOTER //
// ./src/lang/malay.js